module.exports = __webpack_public_path__ + "img/priority.c6cc201e.png";